"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.createTheme = exports.composeColor = void 0;

var _color = _interopRequireDefault(require("color"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var composeColor = function composeColor(value) {
  var _ref;

  var contrast = (0, _color["default"])(value);

  if (contrast.isDark()) {
    contrast = contrast.lighten(0.8);
  } else {
    contrast = contrast.darken(0.8);
  }

  return _ref = {
    '50': (0, _color["default"])(value).lighten(0.55).hex(),
    '100': (0, _color["default"])(value).lighten(0.5).hex(),
    '200': (0, _color["default"])(value).lighten(0.4).hex(),
    '300': (0, _color["default"])(value).lighten(0.3).hex()
  }, _defineProperty(_ref, "300", (0, _color["default"])(value).lighten(0.2).hex()), _defineProperty(_ref, '400', (0, _color["default"])(value).lighten(0.1).hex()), _defineProperty(_ref, '500', (0, _color["default"])(value).hex()), _defineProperty(_ref, '600', (0, _color["default"])(value).darken(0.1).hex()), _defineProperty(_ref, '700', (0, _color["default"])(value).darken(0.2).hex()), _defineProperty(_ref, '800', (0, _color["default"])(value).darken(0.3).hex()), _defineProperty(_ref, '900', (0, _color["default"])(value).darken(0.4).hex()), _ref;
};

exports.composeColor = composeColor;

var createTheme = function createTheme(params) {
  return Object.fromEntries(Object.entries(params).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        colorName = _ref3[0],
        colorValue = _ref3[1];

    return [colorName, composeColor(colorValue)];
  }));
};

exports.createTheme = createTheme;
var _default = createTheme;
exports["default"] = _default;